function OrderStatus () {
  function filter (value) {
    switch (value) {
      case 'new':
        return 'Novo'

      case 'paid':
        return 'Pago'

      case 'unpaid':
        return 'Não Pago'

      case 'generated':
        return 'Gerado'

      case 'expired':
        return 'Expirado'

      default:
        return 'Desconhecido'
    }
  }

  return {
    filter
  }
}

export default OrderStatus
